'use strict';

import slick from 'slick-carousel';
import SimpleBar from 'simplebar';

import { anchor } from './module/_anchor';
import { carousel } from './module/_carousel';
import { csv } from './module/_csv';
import { inview } from './module/_inview';
import { click } from './module/_click';

const main = (() => {
    /**
     * loaded
     */
    const loaded = () => {
        $('body').addClass('is-loaded');

		setTimeout(function(){
			$('.js-carousel-hero').slick('slickNext');
		}, 1200)

        if(location.hash) {
            anchor.moveTo(null, location.hash, 0, () => {
                inview.init();
            });
        }
        else {
            inview.init();
        }
    };

    /**
     * scrolled
     */
    const scrolled = () => {
        if($(window).scrollTop() >= $(window).outerHeight() / 10) {
            $('body').addClass('is-scrolled');
        }
        else {
            $('body').removeClass('is-scrolled');
        }
    };

    /**
     * resized
     */
    const resized = () => {
        setStyleVarVW();
        setStyleVarVH();
    };

    /**
     * setStyleVarVH
     */
    const setStyleVarVH = () => {
        let vh = $(window).innerHeight() * 0.01;
        document.documentElement.style.setProperty('--vh', vh + 'px');
    };

    /**
     * setStyleVarVW
     */
    const setStyleVarVW = () => {
        let vw = $(window).innerWidth() * 0.01;
        document.documentElement.style.setProperty('--vw', vw + 'px');
    };

    /**
     * init
     */
    const init = () => {
        scrolled();
        resized();

        anchor.init();
        carousel.init();
        csv.init();
        click.init();

		$(".matrix-text span:nth-of-type(2)").each(function() {
			const content = $(this).html();
			const trimText = $.trim(content);
			let newText = "";

			trimText.split("").forEach(function(text) {
			  if(text == ' '){
				newText += '<span> </span>';
			  } else {
				newText += '<span>' + text + '</span>';
			  }
			});
			$(this).html(newText);
		});
    };

    // public
    return {
        init: init,
        loaded: loaded,
        scrolled: scrolled,
        resized: resized,
    };
})();

/**
 * resetCoordinate
 */
export const resetCoordinate = () => {
	$('.js-carousel-coordinate').slick({
		arrows: true,
		variableWidth: true,
		speed: 300
	});

	$('.js-more').on('click', function(event) {
		const $this = $(event.currentTarget);
		const data = $this.data('more');
		$('#more' + data).toggleClass('is-show');
	});

	$('.js-color').on('click', function(event) {
		const $this = $(event.currentTarget);
		const data = $this.data('color');
		const index = data.slice(0, -1);

		$(`.js-color[data-color^=${index}]`).removeClass('is-active');
		$this.addClass('is-active');

		$('img[id^="' + index + '"]').removeClass('is-active');
		$('#' + data).addClass('is-active');
	});
};

$(() => {
    main.init();
});

$(window).on('load', () => {
    main.loaded();
});

$(window).on('scroll', () => {
    main.scrolled();
});

$(window).on('resize', () => {
    setTimeout(() => {
        main.resized();
    }, 100);
});
